import getParent from '../selectors';

export const getGraphTicks = state => getParent(state).graphTicks;
